import Modal from 'components/Modal/Modal'
import {Formik} from 'formik'
import {createOnError} from 'helpers'
import React from 'react'
import {postSchema} from 'apis/schema'
import {SelectEntityItem} from 'components/SelectEntityItem'
import AsyncAction from 'modules/asyncCache/components/AsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import {feed_updateChannel_Api} from "../../apis";
import {createValue} from "../../components/form/utils";
import {Button} from "antd";
import LookupField from "../../components/LookupField";
import getTitle from "../../helpers/getTitle";
import getLinkToDetail from "../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";

const FeedSetChannelForm = ({
                              type,
                              id,
                              onCancel
                            }) => {
  const t = useTranslate()

  return (
    <NavigationContext.Consumer>
      {({handleGoBack}) => (
        <Modal
            width={600}
            title={ <div className="text-center text-color-000 font-bold uppercase">{t('set_channel')}</div> }
            className="custom-modal"
            open={true}
            footer={null}
            closable={false}
            onCancel={ onCancel || handleGoBack }>
            <SelectEntityItem
                item={id}
                schema={postSchema}>
                {item => (
                    <AsyncAction
                        onSuccess={ onCancel || handleGoBack }
                        onError={createOnError()}
                        apiInfo={ feed_updateChannel_Api }
                        query={{ ':type': item._type, ':id': item.id }}>
                        {({ handleAsyncAction, isLoading }) => (
                            <Formik
                                onSubmit={handleAsyncAction}
                                initialValues={{
                                    channel_id: item.container.id
                                }}>
                                {({ values, handleSubmit, handleChange }) => (
                                    <React.Fragment>
                                        <div className="space-x-1 italic mb-6">
                                            <span className="font-semibold text-color-100">
                                                {`* ${t('note')} : `}
                                            </span>
                                            <span className="text-color-300">
                                                {t('the article is being published on the channel')}
                                            </span>
                                            <Link to={getLinkToDetail(item?.container)} className="font-bold text-color-000 no-underline">
                                                {` ${getTitle(item?.container)}.`}
                                            </Link>
                                            <span className="text-color-300">
                                                {t('changing the publishing channel of the article will affect its accessibility to readers')}
                                            </span>
                                        </div>
                                        <div className="text-sm text-color-400 font-medium uppercase mb-1">
                                            {t('Choose the channel for posting')}
                                        </div>
                                        <LookupField
                                            search={false}
                                            createIfNotExists={false}
                                            defaultValue={values.channel_name}
                                            apiPath={`/channels/lookup`}
                                            name="channel_id"
                                            placeholder={t('click to select')}
                                            handleChange={(e) => {
                                                handleChange(createValue('channel_name', e.target.value))
                                                handleChange(createValue('channel_id', e.target.id))
                                            }}
                                        />
                                        <div className="w-full flex items-center justify-end gap-6 py-3 mt-6">
                                                        <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                                                            {t('close')}
                                                        </span>
                                            <Button
                                                onClick={handleSubmit}
                                                type="primary"
                                                className="button-rounded-lg font-medium no-border">
                                                {t('submit')}
                                            </Button>
                                        </div>
                                    </React.Fragment>
                                )}
                            </Formik>
                        )}
                    </AsyncAction>
                )}
            </SelectEntityItem>
        </Modal>
      )}
    </NavigationContext.Consumer>
  )
}
export default FeedSetChannelForm
